const chartColors = {
    light: ['#005A9C', '#A34A00', '#00724C', '#7C3AED', '#BE185D', '#0E7490', '#6B5B00'],
    dark: ['#60A5FA', '#FDBA74', '#34D399', '#C4B5FD', '#F9A8D4', '#67E8F9', '#FDE047'],
};

export const chartColor = (seriesIndex: number, mode: 'light' | 'dark' = 'light') => {
    const colors = chartColors[mode];
    return colors[(seriesIndex % colors.length + colors.length) % colors.length];
};
